module.exports = __webpack_public_path__ + "img/slowmist.b9141124.png";